import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const SignUp = () => import('@/views/SignUp')
const Faq = () => import('@/views/Faq')
const NewFaq = () => import('@/views/NewFaq')
const ManageFaq = () => import('@/views/ManageFaq')
const en = () => import('@/views/en')
const ProClass = () => import('@/views/ProClass')
const RegisterProClass = () => import('@/views/RegisterProClass')
const Legal = () => import('@/views/Legal')
const Guide = () => import('@/views/Guide')
const Comparison = () => import('@/views/Comparison')
const Partner = () => import('@/views/Partner')
const Partners = () => import('@/views/en/Partner')
const Packages = () => import('@/views/en/Package')
const SearchTutor = () => import('@/views/SearchTutor')
const SearchTutors = () => import('@/views/en/SearchTutor')
const About = () => import('@/views/About')
const Contact = () => import('@/views/Contact')
const Help = () => import('@/views/Help')
const GettingStarted = () => import('@/views/GettingStarted')
const AccountSetting = () => import('@/views/AccountSetting')
const Plan = () => import('@/views/Plan')
const Feature = () => import('@/views/Feature')
const Feedback = () => import('@/views/Feedback')
const ReminderPayment = () => import('@/views/ReminderPayment')


const Logins = () => import('@/views/Login')

const LoginTutors = () => import('@/views/tutor/Login')
const LoginStudents = () => import('@/views/student/Login')

const SignUpTutor = () => import('@/views/tutor/SignUp')
const SignUpParent = () => import('@/views/student/SignUp')

const ForgotPasswordTutor = () => import('@/views/tutor/ForgotPassword')
const ForgotPasswordStudent = () => import('@/views/student/ForgotPassword')

const MainPageTutor = () => import('@/views/tutor/MainPage')
const MainPageStudent= () => import('@/views/student/MainPage')



// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')
const Calendar = () => import('@/views/Calendar')

const Home = () => import('@/views/Home')
const RegisterUser = () => import('@/views/RegisterUser')
const Profile = () => import('@/views/Profile')
const SuccessRegister = () => import('@/views/SuccessRegister')
const FindTutor = () => import('@/views/FindTutor')
const CreateNewFindTutor = () => import('@/views/CreateNewFindTutor')
const CreateNewFindTutorGroup = () => import('@/views/CreateNewFindTutorGroup')
const ResultTutor = () => import('@/views/ResultTutor')
const Landing = () => import('@/views/Index')
const UpdateSchedule = () => import('@/views/EditSchedule')
const UpdateScheduleCopy = () => import('@/views/EditScheduleCopy')
const FindSubject = () => import('@/views/FindSubject')
const FindSubjectStatus = () => import('@/views/FindSubjectStatus')
const NotClass = () => import('@/views/NotificationClass')
const ResumeTutor = () => import('@/views/ResumeTutor')
const ResumeTeacher = () => import('@/views/ResumeTeacher')
const Package = () => import('@/views/Package')
const AccptJob = () => import('@/views/AcceptedJob')
const StudentResponse = () => import('@/views/StudentResponse')
const StudentResponseStatus = () => import('@/views/StudentResponseStatus')
const NotificationStudent = () => import('@/views/NotificationStudent')
const StudentSchedule = () => import('@/views/StudentSchedule')
const StudentScheduleStatus = () => import('@/views/StudentScheduleStatus')
const NotificationTeacher = () => import('@/views/NotificationTeacher')
const FindTutorList = () => import('@/views/FindTutorList')
const ConfirmationClass = () => import('@/views/ConfirmationClass')
const ConfirmationClassStatus = () => import('@/views/ConfirmationClassStatus')
const StudentNotificationConfirmClass = () => import('@/views/StudentNotificationConfirmClass')
const RequestSubject = () => import('@/views/StudentRequestSubject')
const StudentAcceptNotification = () => import('@/views/StudentAcceptNotification')
const RegisterStudent = () => import('@/views/RegisterStudent')
const Requests = () => import('@/views/Request')
const ManageSubjectGrade = () => import('@/views/ManageSubjectGrade')
const DirectFindTutor = () => import('@/views/DirectFindTutor')
const DirectOffer = () => import('@/views/DirectOffer')
const Payment = () => import('@/views/Payment')

const TeacherStatus = () => import('@/views/TeacherStatus')
const StudentStatus = () => import('@/views/StudentStatus')

const ProfessionalProfile = () => import('@/views/ProfessionalProfile')
const TeacherProfession = () => import('@/views/TeacherProfession')
const TeacherAcademicProfile = () => import('@/views/TeacherAcademicProfile')
const TeacherAreaExpertise = () => import('@/views/TeacherAreaExpertise')
const TeacherClassGrade = () => import('@/views/TeacherClassGrade')
const TeacherWorkBackground = () => import('@/views/TeacherWorkBackground')
const TeacherSubject = () => import('@/views/TeacherSubject')
const NewSubjectGrade = () => import('@/views/NewSubjectGrade')
const RemoveGradeClass = () => import('@/views/RemoveGradeClass')

const ListWaiting = () => import('@/views/ListWaiting')
const ListRequest = () => import('@/views/ListRequest')

const DetailStudentSchedule = () => import('@/views/DetailStudentSchedule')

// Views - Quiz
const QuizTeacherDashboard = () => import('@/views/QuizTeacherDashboard')
const QuizTeacherStatistic = () => import('@/views/QuizTeacherStatistic')
const QuizTeacherCreateTitle = () => import('@/views/QuizTeacherCreateTitle')
const QuizTeacherCreateQuestion = () => import('@/views/QuizTeacherCreateQuestion')
const QuizTeacherPreview = () => import('@/views/QuizTeacherPreview')
const QuizSubject = () => import('@/views/QuizSubject')
const QuizGrade = () => import('@/views/QuizGrade')
const QuizStudent = () => import('@/views/QuizStudent')
const QuizStudentDashboard = () => import('@/views/QuizStudentDashboard')
const QuizStudentDescription = () => import('@/views/QuizStudentDescription')
const QuizStudentQuestion = () => import('@/views/QuizStudentQuestion')
const QuizStudentOverview = () => import('@/views/QuizStudentOverview')
const QuizStudentLeaderBoard = () => import('@/views/QuizStudentLeaderBoard')
const QuizStudentDaily = () => import('@/views/QuizStudentDaily')
const QuizStudentAnswerPreview = () => import('@/views/QuizStudentAnswerPreview')
const QuizStudentFinalScore = () => import('@/views/QuizStudentFinalScore')
const QuizTeacherQuizList = () => import('@/views/QuizTeacherQuizList')
const QuizTeacherDraft = () => import('@/views/QuizTeacherDraft')

const QuizStudentExam = () => import('@/views/QuizStudentExam')
const QuizTeacherProfile = () => import('@/views/QuizTeacherProfile')
const QuizStudentQuizList = () => import('@/views/QuizStudentQuizList')
const QuizStudentProfile = () => import('@/views/QuizStudentProfile')
const QuizTeacherDescription = () => import('@/views/QuizTeacherDescription')
const QuizTeacherEditQuestion = () => import('@/views/QuizTeacherEditQuestion')
const QuizTeacherTestOverview = () => import('@/views/QuizTeacherTestOverview')
const QuizTeacherLeaderBoard = () => import('@/views/QuizTeacherLeaderBoard')
const QuizTeacherTestResult = () => import('@/views/QuizTeacherTestResult')
const QuizStudentExamList = () => import('@/views/QuizStudentExamList')
const QuizStudentQuizDetail = () => import('@/views/QuizStudentQuizDetail')
const QuizTeacherAcademicProfile = () => import('@/views/QuizTeacherAcademicProfile')
const QuizTeacherWorkBackground = () => import('@/views/QuizTeacherWorkBackground')
const QuizTeacherProfession = () => import('@/views/QuizTeacherProfession')
const QuizTeacherAreaExpertise = () => import('@/views/QuizTeacherAreaExpertise')
const QuizStudentEwallet = () => import('@/views/QuizStudentEwallet')
const QuizStudentListQuestion = () => import('@/views/QuizStudentListQuestion')
const QuizStudentSubscription = () => import('@/views/QuizStudentSubscription')
// Views - Score Card

const ScoreCardStudent = () => import('@/views/ScoreCardStudent')
const ReferProgram = () => import('@/views/ReferralProgram')

const ResumeTutorApp = () => import('@/views/ResumeTutorApp')
const AnswerQuizAll = () => import('@/views/AnswerQuizAll')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
})

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/home',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'Calendar',
          name: 'Calendar',
          component: Calendar
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    },
    
    {
      path: '/',
      redirect: '/',
      name: 'Register',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'SignUp',
          name: 'Sign Up',
          component: SignUp
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Home',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Home',
          name: 'Home',
          component: Home
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Partners',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/en/Partner',
          name: 'Partner',
          component: Partners
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'SearchTutor',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/en/SearchTutor',
          name: 'Partner',
          component: SearchTutors
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Login',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/tutor/Login',
          name: 'Login',
          component: LoginTutors
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'SignUp',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/tutor/SignUp',
          name: 'Sign Up',
          component: SignUpTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ForgotPassword',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/tutor/ForgotPassword',
          name: 'ForgotPassword',
          component: ForgotPasswordTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'MainPage',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/tutor/MainPage',
          name: 'MainPage',
          component: MainPageTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'SignUp',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/student/SignUp',
          name: 'Sign Up',
          component: SignUpParent
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ForgotPassword',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/student/ForgotPassword',
          name: 'ForgotPassword',
          component: ForgotPasswordStudent
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Login',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/student/Login',
          name: 'Login',
          component: LoginStudents
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'MainPage',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/student/MainPage',
          name: 'MainPage',
          component: MainPageStudent
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Packages',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '/en/Package',
          name: 'Package',
          component: Packages
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'RegisterUser',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'RegisterUser',
          name: 'Register',
          component: RegisterUser
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Faq',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Faq',
          name: 'Faq',
          component: Faq
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'SearchTutor',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'SearchTutor',
          name: 'SearchTutor',
          component: SearchTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'en',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'en',
          name: 'Homepage',
          component: en
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ProClass',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ProClass',
          name: 'ProClass',
          component: ProClass
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'RegisterProClass',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'RegisterProClass',
          name: 'RegisterProClass',
          component: RegisterProClass
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Legal',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Legal',
          name: 'Legal',
          component: Legal,
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Comparison',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Comparison',
          name: 'Comparison',
          component: Comparison,
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Partner',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Partner',
          name: 'Partner',
          component: Partner,
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Guide',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Guide',
          name: 'Guide',
          component: Guide,
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ManageFaq',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ManageFaq',
          name: 'ManageFaq',
          component: ManageFaq
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'NewFaq',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'NewFaq',
          name: 'Add Faq',
          component: NewFaq
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Profile',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Profile',
          name: 'Profile',
          component: Profile
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'SuccessRegister',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'SuccessRegister',
          name: 'SuccessRegister',
          component: SuccessRegister
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'FindTutor',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'FindTutor',
          name: 'Find Tutor',
          component: FindTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'CreateNewFindTutor',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'CreateNewFindTutor',
          name: 'Find Tutor',
          component: CreateNewFindTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'CreateNewFindTutorGroup',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'CreateNewFindTutorGroup',
          name: 'Find Tutor',
          component: CreateNewFindTutorGroup
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'FindSubject',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'FindSubject',
          name: 'Find Subject',
          component: FindSubject
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'FindSubjectStatus',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'FindSubjectStatus',
          name: 'Find Subject Status',
          component: FindSubjectStatus
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'ListWaiting',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ListWaiting',
          name: 'List Waiting',
          component: ListWaiting
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ListRequest',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ListRequest',
          name: 'List Request',
          component: ListRequest
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'RegisterStudent',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'RegisterStudent',
          name: 'Register Student',
          component: RegisterStudent
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'RemoveGradeClass',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'RemoveGradeClass',
          name: 'Remove Class',
          component: RemoveGradeClass
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'TeacherStatus',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'TeacherStatus',
          name: 'Find Tutor Status',
          component: TeacherStatus
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'StudentStatus',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'StudentStatus',
          name: 'Find Tutor Status',
          component: StudentStatus
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ConfirmationClass',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ConfirmationClass',
          name: 'Confirmation Class',
          component: ConfirmationClass
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ConfirmationClassStatus',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ConfirmationClassStatus',
          name: 'Confirmation Class Status',
          component: ConfirmationClassStatus
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'StudentNotificationConfirmClass',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'StudentNotificationConfirmClass',
          name: 'Notification',
          component: StudentNotificationConfirmClass
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'StudentResponse',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'StudentResponse',
          name: 'Student Response',
          component: StudentResponse
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'StudentResponseStatus',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'StudentResponseStatus',
          name: 'Student Response Status',
          component: StudentResponseStatus
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'DetailStudentSchedule',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'DetailStudentSchedule',
          name: 'Detail Student Schedule',
          component: DetailStudentSchedule
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'NotificationStudent',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'NotificationStudent',
          name: 'Notification Student',
          component: NotificationStudent
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'StudentSchedule',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'StudentSchedule',
          name: 'Notification',
          component: StudentSchedule
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'StudentScheduleStatus',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'StudentScheduleStatus',
          name: 'Find Tutor Status',
          component: StudentScheduleStatus
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'NotificationTeacher',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'NotificationTeacher',
          name: 'Notification Teacher',
          component: NotificationTeacher
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'FindTutorList',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'FindTutorList',
          name: 'Find Tutor List',
          component: FindTutorList
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'StudentRequestSubject',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'StudentRequestSubject',
          name: 'Request Subject',
          component: RequestSubject
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Accepting',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Request',
          name: 'Request',
          component: Requests
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ProfessionalProfile',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ProfessionalProfile',
          name: 'ProfessionalProfile',
          component: ProfessionalProfile
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'TeacherProfession',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'TeacherProfession',
          name: 'TeacherProfession',
          component: TeacherProfession
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'TeacherAcademicProfile',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'TeacherAcademicProfile',
          name: 'TeacherAcademicProfile',
          component: TeacherAcademicProfile
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'TeacherAreaExpertise',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'TeacherAreaExpertise',
          name: 'TeacherAreaExpertise',
          component: TeacherAreaExpertise
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'TeacherClassGrade',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'TeacherClassGrade',
          name: 'TeacherClassGrade',
          component: TeacherClassGrade
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherCreateTitle',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherCreateTitle',
          name: 'Create Quiz Title',
          component: QuizTeacherCreateTitle
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'TeacherWorkBackground',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'TeacherWorkBackground',
          name: 'TeacherWorkBackground',
          component: TeacherWorkBackground
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'TeacherSubject',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'TeacherSubject',
          name: 'Teacher Subject',
          component: TeacherSubject
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'NewSubjectGrade',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'NewSubjectGrade',
          name: 'Add Subject and Grade',
          component: NewSubjectGrade
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ManageSubjectGrade',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ManageSubjectGrade',
          name: 'ManageSubjectGrade',
          component: ManageSubjectGrade
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'DirectFindTutor',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'DirectFindTutor',
          name: 'DirectFindTutor',
          component: DirectFindTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'AcceptedJob',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'AcceptedJob',
          name: 'Accepted Jobt',
          component: AccptJob
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'StudentAcceptNotification',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'StudentAcceptNotification',
          name: 'Notification',
          component: StudentAcceptNotification
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Package',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Package',
          name: 'Package',
          component: Package
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'NotificationClass',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'NotificationClass',
          name: 'Notification Class',
          component: NotClass
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ResumeTutor',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ResumeTutor',
          name: 'Resume Tutor',
          component: ResumeTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ResumeTutorApp',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ResumeTutorApp',
          name: 'Resume Tutor',
          component: ResumeTutorApp
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ResumeTeacher',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ResumeTeacher',
          name: 'Resume Teacher',
          component: ResumeTeacher
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ResultTutor',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ResultTutor',
          name: 'Result Tutor',
          component: ResultTutor
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Index',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Index',
          name: 'Index',
          component: Landing
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'EditSchedule',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'EditSchedule',
          name: 'Edit Schedule',
          component: UpdateSchedule
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'EditScheduleCopy',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'EditScheduleCopy',
          name: 'Edit Schedule',
          component: UpdateScheduleCopy
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizGrade',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizGrade',
          name: 'Quiz Grade',
          component: QuizGrade
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherDashboard',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherDashboard',
          name: 'Quiz Teacher Dashboard',
          component: QuizTeacherDashboard
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherStatistic',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherStatistic',
          name: 'Quiz Teacher Statistic',
          component: QuizTeacherStatistic
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizSubject',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizSubject',
          name: 'Quiz Subject',
          component: QuizSubject
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentQuestion',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentQuestion',
          name: 'Student Quiz Question',
          component: QuizStudentQuestion
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'AnswerQuizAll',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'AnswerQuizAll',
          name: 'Student Quiz Question',
          component: AnswerQuizAll
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherCreateQuestion',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherCreateQuestion',
          name: 'Insert Quiz Question',
          component: QuizTeacherCreateQuestion
        },
      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherPreview',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherPreview',
          name: 'Quiz Details',
          component: QuizTeacherPreview
        },
      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentDashboard',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentDashboard',
          name: 'Quiz Student Dashboard',
          component: QuizStudentDashboard
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudent',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudent',
          name: 'Quiz Student Dashboard',
          component: QuizStudent
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentDescription',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentDescription',
          name: 'Quiz Student Description',
          component: QuizStudentDescription
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentOverview',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentOverview',
          name: 'Quiz Student Overview',
          component: QuizStudentOverview
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentLeaderBoard',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentLeaderBoard',
          name: 'Quiz Student Leader Board',
          component: QuizStudentLeaderBoard
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentDaily',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentDaily',
          name: 'Quiz Student Daily',
          component: QuizStudentDaily
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentExam',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentExam',
          name: 'Test Student Subject',
          component: QuizStudentExam
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentAnswerPreview',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentAnswerPreview',
          name: 'Answer Preview',
          component: QuizStudentAnswerPreview
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherProfile',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherProfile',
          name: 'Quiz Teacher Profile',
          component: QuizTeacherProfile
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentFinalScore',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentFinalScore',
          name: 'Quiz Student FinalScore',
          component: QuizStudentFinalScore
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ScoreCardStudent',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ScoreCardStudent',
          name: 'Score Card Student',
          component: ScoreCardStudent
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentQuizList',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentQuizList',
          name: 'Student Quiz List',
          component: QuizStudentQuizList
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentProfile',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentProfile',
          name: 'Student Profile',
          component: QuizStudentProfile
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherDescription',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherDescription',
          name: 'Quiz Teacher Description',
          component: QuizTeacherDescription
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherQuizList',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherQuizList',
          name: 'Quiz Teacher Quiz List',
          component: QuizTeacherQuizList
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherDraft',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherDraft',
          name: 'Teacher Quiz Draft',
          component: QuizTeacherDraft
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherDescription',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherDescription',
          name: 'Quiz Teacher Description',
          component: QuizTeacherDescription
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherEditQuestion',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherEditQuestion',
          name: 'Quiz Teacher Edit Question',
          component: QuizTeacherEditQuestion
        },

      ]
    },   
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherTestResult',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherTestResult',
          name: 'Quiz Teacher Test Result',
          component: QuizTeacherTestResult
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherLeaderBoard',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherLeaderBoard',
          name: 'Quiz Teacher Leader Board',
          component: QuizTeacherLeaderBoard
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherTestOverview',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherTestOverview',
          name: 'Quiz Teacher Test Overview',
          component: QuizTeacherTestOverview
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentExamList',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentExamList',
          name: 'Quiz Student Exam List',
          component: QuizStudentExamList
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentQuizDetail',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentQuizDetail',
          name: 'Quiz Student Quiz Detail',
          component: QuizStudentQuizDetail
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'DirectOffer',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'DirectOffer',
          name: 'Quiz Student Quiz Detail',
          component: DirectOffer
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherAcademicProfile',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherAcademicProfile',
          name: 'Quiz Teacher Academic Profile',
          component: QuizTeacherAcademicProfile
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherWorkBackground',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherWorkBackground',
          name: 'Quiz Teacher Work Background',
          component: QuizTeacherWorkBackground
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherProfession',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherProfession',
          name: 'Quiz Teacher Profession',
          component: QuizTeacherProfession
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizTeacherAreaExpertise',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizTeacherAreaExpertise',
          name: 'Quiz Teacher Area Expertise',
          component: QuizTeacherAreaExpertise
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'About',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'About',
          name: 'About Us',
          component: About
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Contact',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Contact',
          name: 'Contact Us',
          component: Contact
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Payment',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Payment',
          name: 'Payment',
          component: Payment
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Help',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Help',
          name: 'Help',
          component: Help
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'GettingStarted',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'GettingStarted',
          name: 'GettingStarted',
          component: GettingStarted
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'AccountSetting',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'AccountSetting',
          name: 'AccountSetting',
          component: AccountSetting
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Plan',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Plan',
          name: 'Plan',
          component: Plan
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Feature',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Feature',
          name: 'Feature',
          component: Feature
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Feedback',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Feedback',
          name: 'Feedback',
          component: Feedback
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'ReminderPayment',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ReminderPayment',
          name: 'ReminderPayment',
          component: ReminderPayment
        },

      ]
    },
    {
      path: '/',
      redirect: '/',
      name: 'Login',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'Login',
          name: 'Login',
          component: Logins
        },

      ]
    },
    
    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentEwallet',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentEwallet',
          name: 'Quiz Student Ewallet',
          component: QuizStudentEwallet
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentListQuestion',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentListQuestion',
          name: 'Quiz Student List Question',
          component: QuizStudentListQuestion
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'QuizStudentSubscription',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'QuizStudentSubscription',
          name: 'Quiz Student Subscription',
          component: QuizStudentSubscription
        },

      ]
    },

    {
      path: '/',
      redirect: '/',
      name: 'ReferralProgram',     
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'ReferralProgram',
          name: 'Referral Porgram',
          component: ReferProgram
        },

      ]
    }
    
  ]
}
